<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết kiểm kê tài sản</strong>
                    </div>
                    <div class="document-view">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Số biên bản:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.code" :title="assetInventory.code" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <!--<b-col sm="6">
                                <b-form-group label="Tên đợt kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.name" :title="assetInventory.name" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>-->
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ: "
                                              label-for="unit"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.syncSourceType == 1 ?'Phần mềm quản lý tài sản công' : 'Phần mềm khác tại các đơn vị'" :title="assetInventory.syncSourceType == 1 ?'Phần mềm quản lý tài sản công' : 'Phần mềm khác tại các đơn vị'" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị đồng bộ:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.syncUnitName" :title="assetInventory.syncUnitName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="assetInventory.syncDate | formatTime" :title="assetInventory.syncDate | formatTime" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tài khoản đồng bộ:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.syncUserName" :title="assetInventory.syncUserName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <!--<b-col sm="6">
                                <b-form-group label="Ngày duyệt:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.approvedDate | formatDate" :title="assetInventory.approvedDate | formatDate" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>-->
                            <b-col sm="6">
                                <b-form-group label="Đơn vị kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.unitName" :title="assetInventory.unitFullName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Ngày kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.inventoryDate | formatDate" :title="assetInventory.inventoryDate | formatDate" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <!--<b-col sm="6">
                                <b-form-group label="Hình thức kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="getInventoryForm(assetInventory.inventoryForm)" :title="getInventoryForm(assetInventory.inventoryForm)" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="assetInventory.inventoryForm == 4">
                                <b-form-group label="Tên hình thức kiểm kê khác:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.inventoryFormOther" :title="assetInventory.inventoryFormOther" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>-->
                            <!--<b-col sm="6">
                                <b-form-group label="Người duyệt:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.approver" :title="assetInventory.approver" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="getInventoryStatus(assetInventory.status)" :title="getInventoryStatus(assetInventory.inventoryStatus)" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>-->
                            <b-col sm="6">
                                <b-form-group label="Bộ phận/phòng ban sử dụng:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.departmentName" :title="assetInventory.departmentName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đại diện bộ phận/phòng ban:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetInventory.departmentRepresentative" :title="assetInventory.departmentRepresentative" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col sm="12">
                                <b-form-group label="Hội đồng kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <input-auto-size :value="assetInventory.inventoryCommittee"></input-auto-size>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group label="Ghi chú:"
                                              label-for="input-unit"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <input-auto-size :value="assetInventory.notes"></input-auto-size>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                    </div>
                    <template v-if="assetInventory.id">
                        <br />
                        <b-grid :items="assetInventory.committees"
                                :gridOptions="gridOptionsCommitee"
                                :showActions="false"
                                gridName="Thành phần tham gia kiểm kê">
                            <template v-slot:cell(position)="row">
                                {{ row.value == 2 ? 'Trưởng ban' : 'Ủy viên' }}
                            </template>
                        </b-grid>
                        <br />
                        <b-grid :items="assetInventory.details.filter(x => x.quantity > 0)"
                                :gridOptions="gridOptions"
                                :showActions="false"
                                :filter="searchForm.filter"
                                gridName="Danh sách tài sản">
                            <template v-slot:actions>
                                <b-form @submit.prevent="searchData">
                                    <b-form-input v-model="searchForm.filter" placeholder="Nhập từ khóa"></b-form-input>
                                </b-form>
                            </template>
                            <template v-slot:cell(originalValue)="row">
                                {{ row.value | currency }}
                            </template>
                            <template v-slot:cell(residualValue)="row">
                                {{ row.value | currency }}
                            </template>
                            <!--<template v-slot:cell(quantity)="row">
                                {{ row.value | formatNumber }}
                            </template>
                            <template v-slot:cell(quantityInventory)="row">
                                {{ row.value | formatNumber }}
                            </template>
                            <template v-slot:cell(quantityDifference)="row">
                                {{ row.value | formatNumber }}
                            </template>-->
                            <!--<template v-slot:cell(relatedMutation)="row">
                                <router-link :to="{ path: `/data/asset-mutations/${row.item.relatedAssetMutationId}` }">
                                    {{ row.item.relatedAssetMutationTypeName }}
                                </router-link>
                            </template>
                            <template v-slot:cell(assetCode)="row">
                                <router-link :to="{ path: `/data/assets/${row.item.assetId}` }">
                                    {{ row.value }}
                                </router-link>
                            </template>-->
                        </b-grid>
                        <br />
                        <b-grid :items="assetInventory.details.filter(x => x.quantity == 0)"
                                :gridOptions="gridOptionsExcess"
                                :showActions="false"
                                :filter="searchForm.filter"
                                gridName="Danh sách tài sản phát hiện thừa">
                            <template v-slot:actions>
                                <b-form @submit.prevent="searchData">
                                    <b-form-input v-model="searchForm.filterExcess" placeholder="Nhập từ khóa"></b-form-input>
                                </b-form>
                            </template>
                            <template v-slot:cell(originalValue)="row">
                                {{ row.value | currency }}
                            </template>
                            <template v-slot:cell(residualValue)="row">
                                {{ row.value | currency }}
                            </template>
                            <!--<template v-slot:cell(quantity)="row">
                                {{ row.value | formatNumber }}
                            </template>
                            <template v-slot:cell(quantityInventory)="row">
                                {{ row.value | formatNumber }}
                            </template>
                            <template v-slot:cell(quantityDifference)="row">
                                {{ row.value | formatNumber }}
                            </template>-->
                            <!--<template v-slot:cell(relatedMutation)="row">
                                <router-link :to="{ path: `/data/asset-mutations/${row.item.relatedAssetMutationId}` }">
                                    {{ row.item.relatedAssetMutationTypeName }}
                                </router-link>
                            </template>
                            <template v-slot:cell(assetCode)="row">
                                <router-link :to="{ path: `/data/assets/${row.item.assetId}` }">
                                    {{ row.value }}
                                </router-link>
                            </template>-->
                        </b-grid>
                    </template>
                    <b-row>
                        <b-col class="text-center">
                            <div class="form-group">
                                <b-button type="button" :to="{ path: '/data/organization-assets/asset-inventories/list' }">Quay lại</b-button>
                                <!--<b-button type="button" :to="{ path: `/data/asset-mutations/list?assetCode=${assetExploitationDecision.code}&unitOption=2` }">Danh sách biến động</b-button>-->
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'AssetInventoryDetail',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    filter: null,
                    filterExcess: null,
                },
                gridOptionsCommitee: {
                    fields: [
                        { key: 'fullName', label: 'Họ tên', sortable: true, sortDirection: 'asc', thAttr: { width: 160 } },
                        { key: 'title', label: 'Chức vụ', sortable: true },
                        { key: 'department', label: 'Đại diện', sortable: true },
                        { key: 'position', label: 'Tên vị trí', sortable: true },
                    ],
                    sortBy: 'assetCode',
                },
                gridOptions: {
                    fields: [
                        { key: 'assetCode', label: 'Mã tài sản', sortable: true, sortDirection: 'asc', thAttr: { width: 160 } },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true, tdClass: 'text-right' },
                        { key: 'residualValue', label: 'Giá trị còn lại', sortable: true, tdClass: 'text-right' },
                        //{ key: 'quantity', label: 'Số lượng KT', sortable: true, tdClass: 'text-right' },
                        { key: 'quantityInventory', label: 'Số lượng', sortable: true, tdClass: 'text-right' },
                        //{ key: 'quantityDifference', label: 'Chênh lệch', sortable: true, tdClass: 'text-right' },
                        { key: 'usageState', label: 'Tình trạng', sortable: true },
                        { key: 'handlingProposed', label: 'Kiến nghị giải quyết tài sản thiếu', sortable: true },
                        //{ key: 'handlingResult', label: 'Kết quả xử lý', sortable: true },
                        //{ key: 'relatedMutation', label: 'Biến động TS', sortable: true },
                        { key: 'notes', label: 'Ghi chú', sortable: true },
                    ],
                    sortBy: 'Id',
                },
                gridOptionsExcess: {
                    fields: [
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true, tdClass: 'text-right' },
                        { key: 'residualValue', label: 'Giá trị còn lại', sortable: true, tdClass: 'text-right' },
                        //{ key: 'quantity', label: 'Số lượng KT', sortable: true, tdClass: 'text-right' },
                        { key: 'quantityInventory', label: 'Số lượng', sortable: true, tdClass: 'text-right' },
                        //{ key: 'quantityDifference', label: 'Chênh lệch', sortable: true, tdClass: 'text-right' },
                        { key: 'usageState', label: 'Tình trạng', sortable: true },
                        { key: 'handlingProposed', label: 'Kiến nghị giải quyết tài sản thừa', sortable: true },
                        //{ key: 'handlingResult', label: 'Kết quả xử lý', sortable: true },
                        //{ key: 'relatedMutation', label: 'Biến động TS', sortable: true },
                        { key: 'notes', label: 'Ghi chú', sortable: true },
                    ],
                    sortBy: 'Id',
                },
                assetInventory: {

                },
                detailsShowing: false
            }
        },
        computed: {
            assetInventoryId() {
                return this.$route.params.assetInventoryId;
            },
            ...mapState({
                inventoryForms: (state) => state.common.inventoryForms,
                inventoryStatuses: (state) => state.common.inventoryStatuses
            })
        },
        created() {
            this.loadInventoryDetail();
        },
        methods: {
            loadInventoryDetail() {
                var vm = this;
                return this.$services.get(`data/asset-inventories/${this.assetInventoryId}`).done(data => {
                    vm.assetInventory = data;
                });
            },
            getInventoryForm(value) {
                if (!isNaN(value)) {
                    var form = this.inventoryForms[value - 1];
                    return form ? form.text : '';
                }
            },
            getInventoryStatus(value) {
                if (!isNaN(value)) {
                    var status = this.inventoryStatuses[value - 1];
                    return status ? status.text : '';
                }
            }
        },
        watch: {
            assetInventoryId() {
                this.loadInventoryDetail();;
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
